module.exports = __webpack_public_path__ + "assets/img/法人证书1.813acc6d.png";